import { fetchCollection } from './index'

import { workSummarySchema } from '../schemas'

export const WORK_SUMMARIES_REQUEST = 'WORK_SUMMARIES_REQUEST'
export const WORK_SUMMARIES_SUCCESS = 'WORK_SUMMARIES_SUCCESS'
export const WORK_SUMMARIES_FAILURE = 'WORK_SUMMARIES_FAILURE'

function fetchWorkSummaries (url, reload) {
  return fetchCollection({
    url,
    key: 'workSummaries',
    schema: workSummarySchema,
    actions: [ WORK_SUMMARIES_REQUEST, WORK_SUMMARIES_SUCCESS, WORK_SUMMARIES_FAILURE ],
    responseInterceptor: (response) => ({ ...response, reload })
  })
}

const SummaryQuery = Object.freeze({
  all: "all",
  inProgress: "inProgress",
  pendingArchived: "pendingArchived"
})

function loadWorkSummaries ({ requestType = SummaryQuery.all, search = '', nextPage = false } = {}) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = getState().pagination.workSummaries

    if (!nextPage) {
      const requestTypeCases = Object.freeze({
        all: `/work_summaries?search=${search}`,
        inProgress: `/work_summaries?types[]=open&types[]=in_progress&search=${search}`,
        pendingArchived: `/work_summaries?types[]=signed_off&types[]=pending_approval&search=${search}`
      })

      nextPageUrl = requestTypeCases[requestType] || requestTypeCases.all
    }
    return dispatch(fetchWorkSummaries(nextPageUrl, !nextPage))
  }
}

export function loadAllWorkSummaries (search, nextPage) {
  return loadWorkSummaries({ requestType: SummaryQuery.all, nextPage })
}

export function loadInProgressWorkSummaries (search, nextPage) {
  return loadWorkSummaries({ requestType: SummaryQuery.inProgress, search, nextPage })
}

export function loadPendingArchivedWorkSummaries (search, nextPage) {
  return loadWorkSummaries({ requestType: SummaryQuery.pendingArchived, search, nextPage })
}



// WEBPACK FOOTER //
// ./src/actions/work-summaries.js